import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    id,
    name,
    cateIds,
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.kpi.dep.save, {
        id,
        name,
        cateIds,
    }, options);
    if (error) return { error, status };
    return content || {};
};
